import { render } from "./OrderStatus.vue?vue&type=template&id=2b41296b"
import script from "./OrderStatus.vue?vue&type=script&lang=js"
export * from "./OrderStatus.vue?vue&type=script&lang=js"

import "./OrderStatus.vue?vue&type=style&index=0&id=2b41296b&lang=css"

import exportComponent from "/Users/wouter/Vue-apps/BRGR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__